import { SelectionModel } from '@angular/cdk/collections';
import { Pipe, PipeTransform } from '@angular/core';

import { RDS_DATA_DICTIONARY_COLUMNS, RdsDataDictionaryTableColumn } from './column.model';

@Pipe({
  name: 'isColumnSelected',
})
export class IsColumnSelectedPipe implements PipeTransform {
  transform(length: number, selection: SelectionModel<RDS_DATA_DICTIONARY_COLUMNS>, column: RdsDataDictionaryTableColumn): boolean {
    return length ? selection.isSelected(column.property) : false;
  }
}
